/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApplePayMerchantDomainsGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type GetApplePayMerchantDomainsRequest = {
  /**
   * ID of the Moov account representing the merchant.
   */
  accountID: string;
};

export type GetApplePayMerchantDomainsResponse = {
  headers: { [k: string]: Array<string> };
  result: components.ApplePayMerchantDomains;
};

/** @internal */
export const GetApplePayMerchantDomainsGlobals$inboundSchema: z.ZodType<
  GetApplePayMerchantDomainsGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type GetApplePayMerchantDomainsGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const GetApplePayMerchantDomainsGlobals$outboundSchema: z.ZodType<
  GetApplePayMerchantDomainsGlobals$Outbound,
  z.ZodTypeDef,
  GetApplePayMerchantDomainsGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function getApplePayMerchantDomainsGlobalsToJSON(
  getApplePayMerchantDomainsGlobals: GetApplePayMerchantDomainsGlobals,
): string {
  return JSON.stringify(
    GetApplePayMerchantDomainsGlobals$outboundSchema.parse(
      getApplePayMerchantDomainsGlobals,
    ),
  );
}
export function getApplePayMerchantDomainsGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<GetApplePayMerchantDomainsGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApplePayMerchantDomainsGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApplePayMerchantDomainsGlobals' from JSON`,
  );
}

/** @internal */
export const GetApplePayMerchantDomainsRequest$inboundSchema: z.ZodType<
  GetApplePayMerchantDomainsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
});
/** @internal */
export type GetApplePayMerchantDomainsRequest$Outbound = {
  accountID: string;
};

/** @internal */
export const GetApplePayMerchantDomainsRequest$outboundSchema: z.ZodType<
  GetApplePayMerchantDomainsRequest$Outbound,
  z.ZodTypeDef,
  GetApplePayMerchantDomainsRequest
> = z.object({
  accountID: z.string(),
});

export function getApplePayMerchantDomainsRequestToJSON(
  getApplePayMerchantDomainsRequest: GetApplePayMerchantDomainsRequest,
): string {
  return JSON.stringify(
    GetApplePayMerchantDomainsRequest$outboundSchema.parse(
      getApplePayMerchantDomainsRequest,
    ),
  );
}
export function getApplePayMerchantDomainsRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApplePayMerchantDomainsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApplePayMerchantDomainsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApplePayMerchantDomainsRequest' from JSON`,
  );
}

/** @internal */
export const GetApplePayMerchantDomainsResponse$inboundSchema: z.ZodType<
  GetApplePayMerchantDomainsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.ApplePayMerchantDomains$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type GetApplePayMerchantDomainsResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.ApplePayMerchantDomains$Outbound;
};

/** @internal */
export const GetApplePayMerchantDomainsResponse$outboundSchema: z.ZodType<
  GetApplePayMerchantDomainsResponse$Outbound,
  z.ZodTypeDef,
  GetApplePayMerchantDomainsResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.ApplePayMerchantDomains$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function getApplePayMerchantDomainsResponseToJSON(
  getApplePayMerchantDomainsResponse: GetApplePayMerchantDomainsResponse,
): string {
  return JSON.stringify(
    GetApplePayMerchantDomainsResponse$outboundSchema.parse(
      getApplePayMerchantDomainsResponse,
    ),
  );
}
export function getApplePayMerchantDomainsResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetApplePayMerchantDomainsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApplePayMerchantDomainsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApplePayMerchantDomainsResponse' from JSON`,
  );
}
